import { TravelCollectionState } from './reducer';
import { RootState } from '../../../store';
import {
  getTravelCollectionTargeting,
  toSlotTargeting,
} from '../../../lib/adTargeting';
import adSizes from '../adSizes';
import { Ads } from '../../../components/presentational/Ad';

interface State extends RootState {
  travelCollection: TravelCollectionState;
}

export type TravelCollection = State['travelCollection'];
export type Brand = State['travelCollection']['brand'];
export type AdConfig = State['travelCollection']['adConfig'];
export type StoriesBlock = State['travelCollection']['storiesBlock'];
export type AquisitionHero = State['travelCollection']['acquisitionHero'];

export const travelCollectionSelector = ({
  travelCollection,
}: State): TravelCollection => travelCollection;

export const moreArticlesURLSelector = ({
  travelCollection: { storiesBlock },
}: State): string =>
  storiesBlock && storiesBlock.linkUrl ? storiesBlock.linkUrl : '';

export const moreHolidaysURLSelector = ({
  travelCollection: { holidaysBlock },
}: State): string => (holidaysBlock && holidaysBlock.moreHolidaysURL) || '';

export const adsSelector = ({ travelCollection }: State): Ads => {
  const { hideAds, adConfig } = travelCollection;

  if (hideAds) return {};

  const targeting = toSlotTargeting(
    getTravelCollectionTargeting(travelCollection)
  );

  return Object.keys(adConfig.units).reduce(
    (acc, slot) => ({
      ...acc,
      [slot]: {
        ...adSizes[slot],
        adUnitPath: adConfig.units[slot],
        targeting,
      },
    }),
    {}
  );
};
